import { ChangeEvent } from "react";

type InvoiceWebPaginationProps = {
  page: any;
  size: any;
  total: any;
  t: (key: string) => string;
  onChangePage: (page: any) => void;
  onChangeSize: (size: any) => void;
};

export const InvoiceWebPagination = ({
  page,
  size,
  total,
  t,
  onChangePage,
  onChangeSize,
}: InvoiceWebPaginationProps) => {
  const handleChangeSize = (event: ChangeEvent<HTMLSelectElement>) => {
    onChangeSize(event.target.value);
  };

  return (
    <div className="flex relative mt-10 justify-between">
      <div className="pt-2 w-1/4">
        <p>
          {t("OTHER.showing")} {page + 1} {t("OTHER.to")} {size}{" "}
          {t("OTHER.from")} {total} data
        </p>
      </div>
      <div className="w-auto">
        <div>
          <select
            onChange={handleChangeSize}
            value={size}
            className="py-2 border rounded-lg bg-white"
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={1000}>1000</option>
          </select>
          <span className="ml-1">{t("OTHER.entry")}</span>
        </div>
      </div>
      <div className="flex w-1/4">
        <button
          onClick={() => onChangePage(page - 1)}
          disabled={page === 0}
          className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
        >
          {t("OTHER.previous")}
        </button>
        <button
          onClick={() => onChangePage(page + 1)}
          disabled={(page + 1) * size > total}
          className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
        >
          {t("OTHER.next")}
        </button>
      </div>
    </div>
  );
};
